(function ($) {
    
    var preload_element_background = function () {
        $('[preload-background]').each(function () {
            var elem = $(this);
            var src = elem.attr('preload-background');
            var duration = elem.attr('preload-duration') > 0 ? parseFloat(elem.attr('preload-duration')) : 300;
            var delay = elem.attr('preload-delay') > 0 ? parseFloat(elem.attr('preload-delay')) : 0;
            elem[0].delay = delay;
            elem[0].duration = duration;
            elem[0].src = src;
            $.preload(src, 1, function () {
                elem.css('background-image', "url(" + src + ")");
                elem.delay(delay).fadeIn(duration, function () {
                    elem[0].preloaded = true;
                });
            });
        });
    };
    $(preload_element_background);

})(jQuery);